import { OrganizationMs, useFetchApiRequest, useFetchApiRequestAsync } from 'auth-package'
import { ManageProfile } from 'auth-package'
import { defineStore } from 'pinia'
import { EConsoleType, useConsoleMessage } from '@/composables/useConsoleMessage'
import { ElMessage } from 'element-plus'

interface Invitation {

}

interface InvitationState {
    invitations: Array<Invitation>
}

export const useInvitationManagerStore = defineStore('invitation-manager', {
    state: (): InvitationState => {
        return {
            invitations: []
        }
    },
    getters: {

    },
    actions: {
        /**
         * Get the account details from the server
         */
        async getInvitationList(organizationId: string) {

            const inviteList = OrganizationMs.InviteList();

            inviteList.setParameters({
                organizationId: organizationId
            })

            try {
                const response = await useFetchApiRequestAsync(inviteList)
                this.invitations = response

                useConsoleMessage(EConsoleType.SUCCESS, 'invitationList', response)
            } catch (error: any) {
                this.invitations = [];
                useConsoleMessage(EConsoleType.ERROR, 'invitationList', error)
            }
        },

        async revokeInvitation(organizationId: string, invitationId: string) {

            const inviteList = OrganizationMs.InviteRevoke();

            inviteList.setParameters({
                organizationId: organizationId,
                invitationId: invitationId,
            })

            try {
                const response = await useFetchApiRequestAsync(inviteList)

                useConsoleMessage(EConsoleType.SUCCESS, 'invitationList', response)
                await this.getInvitationList(organizationId);

                return true;
            } catch (error: any) {
                useConsoleMessage(EConsoleType.ERROR, 'invitationList', error)

            }
            return false;
        },

        async getInvitation(organizationId: string, invitationToken: string) {
            const getInvite = OrganizationMs.InviteGet();

            getInvite.setParameters({
                organizationId: organizationId,
                inviteToken: invitationToken,
            });

            try {
                const response = await useFetchApiRequestAsync(getInvite);

                useConsoleMessage(EConsoleType.SUCCESS, 'invitationList', response)
                return response;
            } catch (error: any) {
                useConsoleMessage(EConsoleType.ERROR, 'invitationList', error)
                throw error;
            }
        },

        async acceptInvitation(organizationId: string, invitationToken: string, userDetails?: any) {
            const getInvite = OrganizationMs.InviteAccept();

            getInvite.setParameters({
                organizationId: organizationId,
                inviteToken: invitationToken,
            });

            getInvite.setData(userDetails);

            try {
                const response = await useFetchApiRequestAsync(getInvite);

                useConsoleMessage(EConsoleType.SUCCESS, 'invitationList', response)
                return response;
            } catch (error: any) {
                useConsoleMessage(EConsoleType.ERROR, 'invitationList', error)
                throw error;
            }
        },
        async declineInvitation(organizationId: string, invitationToken: string,) {
            const getInvite = OrganizationMs.InviteDecline();

            getInvite.setParameters({
                organizationId: organizationId,
                inviteToken: invitationToken,
            });
            
            try {
                const response = await useFetchApiRequestAsync(getInvite);

                useConsoleMessage(EConsoleType.SUCCESS, 'invitationList', response)
                return response;
            } catch (error: any) {
                useConsoleMessage(EConsoleType.ERROR, 'invitationList', error)
                throw error;
            }
        },
    }
})
